/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_EmailInputs */

const vi_shop_contact_email = /** @type {(inputs: Shop_Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email liên hệ`)
};

/**

* @param {Shop_Contact_EmailInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_email = /** @type {((inputs?: Shop_Contact_EmailInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_EmailInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_email(inputs)
});